import { PromoCodesList as PromoCodesListComponent } from 'components/promoCodes/PromoCodesList/PromoCodesList'
import { useParams } from 'react-router-dom'

export const SellerPromoCodes: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <PromoCodesListComponent sellerId={id as string} />
}
